import { Skeleton, Stack } from '@mui/material'
import type { FC } from 'react'

import { COLORS, unit } from '@hcr/ui'

import { LayoutBookingOverviewHero } from '../layout-booking-overview'

export const BookingOverviewHeroCardLoading: FC = () => {
  return (
    <LayoutBookingOverviewHero>
      <Stack direction='row' paddingLeft={unit(10)}>
        <Stack direction='column' paddingRight={unit(6)}>
          <Skeleton width={unit(50)} height={unit(5.5)} sx={{ bgcolor: COLORS.white }} />
          <Stack direction='column' paddingRight={unit(10.5)}>
            <Skeleton width={unit(30)} height={unit(7)} sx={{ bgcolor: COLORS.white }} />
            <Skeleton width={unit(30)} height={unit(7)} sx={{ bgcolor: COLORS.white }} />
          </Stack>
        </Stack>
      </Stack>
    </LayoutBookingOverviewHero>
  )
}
